import "core-js/modules/es.array.reverse.js";
var _class, _SocrataCatalogStratum;
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { action, computed, runInAction, makeObservable } from "mobx";
import URI from "urijs";
import isDefined from "../../../Core/isDefined";
import loadJson from "../../../Core/loadJson";
import runLater from "../../../Core/runLater";
import TerriaError, { networkRequestError } from "../../../Core/TerriaError";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import GroupMixin from "../../../ModelMixins/GroupMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import { InfoSectionTraits, MetadataUrlTraits } from "../../../Traits/TraitsClasses/CatalogMemberTraits";
import SocrataCatalogGroupTraits, { FacetFilterTraits } from "../../../Traits/TraitsClasses/SocrataCatalogGroupTraits";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
import CatalogGroup from "../CatalogGroup";
import CsvCatalogItem from "../CatalogItems/CsvCatalogItem";
import GeoJsonCatalogItem from "../CatalogItems/GeoJsonCatalogItem";
import SocrataMapViewCatalogItem from "../CatalogItems/SocrataMapViewCatalogItem";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
export let SocrataCatalogStratum = (_class = (_SocrataCatalogStratum = class SocrataCatalogStratum extends LoadableStratum(SocrataCatalogGroupTraits) {
  static async load(catalogGroup) {
    if (!catalogGroup.url) throw "`url` must be set";
    const filterQuery = Object.assign({}, catalogGroup.filterQuery, {
      only: "dataset,map"
    });
    const domain = URI(catalogGroup.url).hostname();
    let facets = [];
    let results = [];

    // If not facet filters have been set - get facets
    if (!isDefined(catalogGroup.facetFilters) || catalogGroup.facetFilters.length === 0) {
      const facetsToUse = catalogGroup.facetGroups;
      const facetUri = URI("".concat(catalogGroup.url, "/api/catalog/v1/domains/").concat(domain, "/facets")).addQuery(filterQuery);
      const facetResponse = await loadJson(proxyCatalogItemUrl(catalogGroup, facetUri.toString()));
      if (facetResponse.error) {
        var _facetResponse$messag;
        throw (_facetResponse$messag = facetResponse.message) !== null && _facetResponse$messag !== void 0 ? _facetResponse$messag : facetResponse.error;
      }
      facets = facetResponse;
      if (!Array.isArray(facets)) throw "Could not fetch facets for domain ".concat(domain);
      facets = facets.filter(f => facetsToUse.includes(f.facet));
      if (facets.length === 0) throw "Could not find any facets for domain ".concat(domain);
    }

    // If facetFilter is set, use it to search for datasets (aka resources)
    else {
      const resultsUri = URI("".concat(catalogGroup.url, "/api/catalog/v1?search_context=").concat(domain)).addQuery(filterQuery);
      catalogGroup.facetFilters.forEach(_ref => {
        let {
          name,
          value
        } = _ref;
        return name && isDefined(value) ? resultsUri.addQuery(name, value) : null;
      });
      const resultsResponse = await loadJson(proxyCatalogItemUrl(catalogGroup, resultsUri.toString()));
      if (resultsResponse.error) {
        var _resultsResponse$mess;
        throw (_resultsResponse$mess = resultsResponse.message) !== null && _resultsResponse$mess !== void 0 ? _resultsResponse$mess : resultsResponse.error;
      }
      results = resultsResponse.results;
      if (!Array.isArray(results) || results.length === 0) throw "Could not find any results for domain ".concat(domain, " and facets: ").concat(catalogGroup.facetFilters.map(_ref2 => {
        let {
          name,
          value
        } = _ref2;
        return "".concat(name, " = ").concat(value);
      }).join(", "));
    }
    return new SocrataCatalogStratum(catalogGroup, facets, results);
  }
  duplicateLoadableStratum(model) {
    return new SocrataCatalogStratum(model, this.facets, this.results);
  }
  constructor(catalogGroup, facets, results) {
    super();
    this.catalogGroup = catalogGroup;
    this.facets = facets;
    this.results = results;
    makeObservable(this);
  }
  get members() {
    // If we only have one facet, return it's children instead of a single facet group
    if (this.facets.length === 1) return this.facets[0].values.map(facetValue => "".concat(this.getFacetId(this.facets[0]), "/").concat(facetValue.value));
    return [...this.facets.map(f => this.getFacetId(f)), ...this.results.map(r => this.getResultId(r))];
  }
  createMembers() {
    this.facets.forEach(facet => this.createGroupFromFacet(facet));
    this.results.forEach(result => this.createItemFromResult(result));
  }

  /** Turn facet into SocrataCatalogGroup */
  createGroupFromFacet(facet) {
    const facetGroupId = this.getFacetId(facet);

    // Create group for Facet
    let facetGroup = this.catalogGroup.terria.getModelById(CatalogGroup, facetGroupId);
    if (facetGroup === undefined) {
      facetGroup = new CatalogGroup(facetGroupId, this.catalogGroup.terria, undefined);
      this.catalogGroup.terria.addModel(facetGroup);
    }

    // Replace the stratum inherited from the parent group.
    facetGroup.strata.delete(CommonStrata.definition);
    facetGroup.setTrait(CommonStrata.definition, "name", facet.facet);

    // Create child groups for Facet values
    facet.values.forEach(facetValue => {
      var _facetValue$count;
      const facetValueId = "".concat(facetGroupId, "/").concat(facetValue.value);
      let facetValueGroup = this.catalogGroup.terria.getModelById(SocrataCatalogGroup, facetValueId);
      if (facetValueGroup === undefined) {
        facetValueGroup = new SocrataCatalogGroup(facetValueId, this.catalogGroup.terria, undefined);
        this.catalogGroup.terria.addModel(facetValueGroup);
      }

      // Replace the stratum inherited from the parent group.
      facetValueGroup.strata.delete(CommonStrata.definition);
      facetValueGroup.setTrait(CommonStrata.definition, "name", "".concat(facetValue.value).concat(facetValue.count ? " (".concat((_facetValue$count = facetValue.count) !== null && _facetValue$count !== void 0 ? _facetValue$count : 0, ")") : ""));
      facetValueGroup.setTrait(CommonStrata.definition, "url", this.catalogGroup.url);
      facetValueGroup.setTrait(CommonStrata.definition, "facetFilters", [createStratumInstance(FacetFilterTraits, {
        name: facet.facet,
        value: facetValue.value
      })]);
      facetGroup.add(CommonStrata.definition, facetValueGroup);
    });
  }

  /** Turn Result into catalog item
   * If type is 'dataset':
   * - If has geometery -> create GeoJSONCatalogItem
   * - Otherwise -> create CsvCatalogItem
   * If type is 'map' -> SocrataMapViewCatalogItem
   * - Then the Socrata `views` API will be used to fetch data (this mimics how Socrata portal map visualisation works - it isn't an official API)
   */
  createItemFromResult(result) {
    const resultId = this.getResultId(result);

    // Add share key for old ID which included parents ID
    this.catalogGroup.terria.addShareKey(resultId, "".concat(this.catalogGroup.uniqueId, "/").concat(result.resource.id));
    let resultModel;

    // If dataset resource
    // - If has geometry - create GeoJSONCatalogItem
    // - Otherwise - create CsvCatalogItem
    if (result.resource.type === "dataset") {
      if (result.resource.columns_datatype.find(type => ["Point", "Line", "Polygon", "MultiLine", "MultiPoint", "MultiPolygon", "Location"].includes(type))) {
        resultModel = this.catalogGroup.terria.getModelById(GeoJsonCatalogItem, resultId);
        if (resultModel === undefined) {
          resultModel = new GeoJsonCatalogItem(resultId, this.catalogGroup.terria, undefined);
          this.catalogGroup.terria.addModel(resultModel);
        }

        // Replace the stratum inherited from the parent group.
        resultModel.strata.delete(CommonStrata.definition);
        resultModel.setTrait(CommonStrata.definition, "url", "".concat(this.catalogGroup.url, "/resource/").concat(result.resource.id, ".geojson?$limit=10000"));
      } else {
        resultModel = this.catalogGroup.terria.getModelById(CsvCatalogItem, resultId);
        if (resultModel === undefined) {
          resultModel = new CsvCatalogItem(resultId, this.catalogGroup.terria, undefined);
          this.catalogGroup.terria.addModel(resultModel);
        }

        // Replace the stratum inherited from the parent group.
        resultModel.strata.delete(CommonStrata.definition);
        resultModel.setTrait(CommonStrata.definition, "url", "".concat(this.catalogGroup.url, "/resource/").concat(result.resource.id, ".csv?$limit=10000"));
      }
      // If type is 'map' -> SocrataMapViewCatalogItem
    } else if (result.resource.type === "map") {
      resultModel = this.catalogGroup.terria.getModelById(SocrataMapViewCatalogItem, resultId);
      if (resultModel === undefined) {
        resultModel = new SocrataMapViewCatalogItem(resultId, this.catalogGroup.terria, undefined);
        this.catalogGroup.terria.addModel(resultModel);
      }

      // Replace the stratum inherited from the parent group.
      resultModel.strata.delete(CommonStrata.definition);
      resultModel.setTrait(CommonStrata.definition, "url", this.catalogGroup.url);
      resultModel.setTrait(CommonStrata.definition, "resourceId", result.resource.id);
    }
    if (resultModel) {
      resultModel.setTrait(CommonStrata.definition, "name", result.resource.name);
      resultModel.setTrait(CommonStrata.definition, "description", result.resource.description);
      resultModel.setTrait(CommonStrata.definition, "attribution", result.resource.attribution);
      resultModel.setTrait(CommonStrata.definition, "info", [createStratumInstance(InfoSectionTraits, {
        name: i18next.t("models.socrataServer.licence"),
        content: result.metadata.license
      }), createStratumInstance(InfoSectionTraits, {
        name: i18next.t("models.socrataServer.tags"),
        content: result.classification.tags.join(", ")
      }), createStratumInstance(InfoSectionTraits, {
        name: i18next.t("models.socrataServer.attributes"),
        content: result.resource.columns_name.join(", ")
      })]);
      resultModel.setTrait(CommonStrata.definition, "metadataUrls", [createStratumInstance(MetadataUrlTraits, {
        title: i18next.t("models.openDataSoft.viewDatasetPage"),
        url: result.permalink
      })]);
    }
  }
  getFacetId(facet) {
    return "".concat(this.catalogGroup.uniqueId, "/").concat(facet.facet);
  }
  getResultId(result) {
    var _this$catalogGroup$ur;
    // Use Socrata server hostname for datasets, so we don't create multiple across facets
    return "".concat(this.catalogGroup.url ? URI((_this$catalogGroup$ur = this.catalogGroup.url) !== null && _this$catalogGroup$ur !== void 0 ? _this$catalogGroup$ur : "").hostname() : this.catalogGroup.uniqueId, "/").concat(result.resource.id);
  }
}, _defineProperty(_SocrataCatalogStratum, "stratumName", "socrataCatalog"), _SocrataCatalogStratum), _applyDecoratedDescriptor(_class.prototype, "members", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "members"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createGroupFromFacet", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createGroupFromFacet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createItemFromResult", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createItemFromResult"), _class.prototype), _class);
StratumOrder.addLoadStratum(SocrataCatalogStratum.stratumName);
export default class SocrataCatalogGroup extends UrlMixin(GroupMixin(CatalogMemberMixin(CreateModel(SocrataCatalogGroupTraits)))) {
  get type() {
    return SocrataCatalogGroup.type;
  }
  async forceLoadMetadata() {
    try {
      if (!this.strata.has(SocrataCatalogStratum.stratumName)) {
        const stratum = await SocrataCatalogStratum.load(this);
        runInAction(() => {
          this.strata.set(SocrataCatalogStratum.stratumName, stratum);
        });
      }
    } catch (e) {
      networkRequestError(TerriaError.from(e, {
        message: {
          key: "models.socrataServer.retrieveErrorMessage"
        }
      }));
    }
  }
  async forceLoadMembers() {
    const socrataServerStratum = this.strata.get(SocrataCatalogStratum.stratumName);
    if (socrataServerStratum) {
      await runLater(() => socrataServerStratum.createMembers());
    }
  }
}
_defineProperty(SocrataCatalogGroup, "type", "socrata-group");